export default {
      id: "arrowDown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.1790760972825.svg#arrowDown-usage",
      toString: function () {
        return this.url;
      }
    }